export const BookRange = (books, from_book, to_book) => {
    const matches = [];
    let in_range = false;
    for (const book of books) {
        if (book.name === from_book) {
            in_range = true;
        }
        if (in_range) {
            matches.push(book);
        }
        if (book.name === to_book) {
            in_range = false;
        }
    }
    return matches;
};
export const FindChapter = (book, chapter) => {
    return book.chapters.find((c) => c.chapter === chapter);
};
export const FindBook = (books, name) => {
    return books.find((b) => b.name === name);
};
